<template lang="pug">
.fam-picker
  //- .instruction {{$t('famPicker.instruction')}}
  .selection
    .selector
      adult-avatar-self(@verify="onFaceVerify")
    //- .selector
    //-   adult-avatar(@click="$emit('addAdult')" @verify="onFaceVerify")
    //- .selector
    //-   child-avatar(@clicked="$emit('addChild')" @verify="onFaceVerify" :child="children.length > 0? children[0] : null")
    //- .selector
    //-   child-avatar(@clicked="$emit('addChild')" @verify="onFaceVerify" :child="children.length > 1? children[1] : null")
</template>
<script>
import AdultAvatar from '@/components/res/AdultAvatar'
import ChildAvatar from '@/components/res/ChildAvatar'
import { mapState } from 'vuex'
import AdultAvatarSelf from '@/components/res/AdultAvatarSelf'
export default {
  name: 'FamPicker',
  components: { AdultAvatarSelf, ChildAvatar, AdultAvatar },
  props: {},
  data() {
    return {}
  },
  computed: {
    ...mapState('app', ['user']),
    children() {
      return this.user.famUsers.filter((user) => {
        return user.userType === 2
      })
    },
  },
  methods: {
    onFaceVerify(id) {
      this.$emit('faceVerify', id)
    },
  },
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "../../styles/common"
.fam-picker
  .instruction
    font-size: pxToRem(30)
  .selection
    width: 100%
    display: flex
    justify-content: flex-start
    flex-wrap: wrap
    align-items: flex-start
    flex-direction: row
    .selector
      margin-right: pxToRem(45)
      margin-top: pxToRem(25)
      width: pxToRem(300)
      text-align: center
</style>
